import { useLang } from "@/contexts/LanguageContext";

const TerminosCondiciones = () => {
  const { t } = useLang();

  return (
    <div data-testid="page-terminos-condiciones">
      <section className="px-6 md:px-12 lg:px-20 pt-16 md:pt-24 pb-12">
        <div className="max-w-4xl mx-auto">
          <div className="text-[11px] uppercase tracking-[0.3em] text-caramel mb-6 font-medium">
            {t.footer.legal}
          </div>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-light tracking-tighter leading-[0.95] text-ink">
            {t.footer.terms}
          </h1>
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-20 pb-24 md:pb-32">
        <article className="max-w-4xl mx-auto space-y-12 text-ink-muted font-light text-base md:text-lg leading-relaxed">
          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              1. Identificación del titular
            </h2>
            <p>
              El presente sitio web <a href="https://www.lacriollita.com" className="text-wine hover:text-wine-hover underline-offset-4 hover:underline">www.lacriollita.com</a> es titularidad de{" "}
              <strong className="text-ink font-medium">BAIRES FOOD SPAIN S.L.</strong>, con CIF B-01998939 y
              domicilio social en C/ Camí de Muntanya nº 7 — 1º, Polígono Industrial de Marratxí, 07141 Mallorca
              (Illes Balears, España). Para cualquier consulta puede dirigirse al correo electrónico{" "}
              <a href="mailto:contacto@lacriollita.eu" className="text-wine hover:text-wine-hover underline-offset-4 hover:underline">contacto@lacriollita.eu</a> o al teléfono +34 646 664 977.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              2. Objeto y ámbito de aplicación
            </h2>
            <p>
              Las presentes Condiciones Generales regulan el acceso, navegación y uso del sitio web, así como el
              procedimiento de solicitud de información y de presupuesto sobre los productos de La Criollita
              (empanadas, alfajores, chipás, dulce de leche, vinos y demás referencias del catálogo). El
              acceso al sitio implica la aceptación expresa de estas condiciones por parte del Usuario.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              3. Productos y disponibilidad
            </h2>
            <p>
              Los productos mostrados en el sitio se ofrecen con fines informativos. La disponibilidad puede
              variar en función del stock, del canal de distribución (HORECA, retail, particular) y del destino
              geográfico. BAIRES FOOD SPAIN S.L. se reserva el derecho a modificar el catálogo, retirar
              referencias o limitar cantidades sin previo aviso.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              4. Solicitud de presupuesto y proceso de pedido
            </h2>
            <p>
              La tienda online del sitio funciona como herramienta de solicitud de presupuesto. El Usuario añade
              referencias al carrito y remite su solicitud por WhatsApp o correo electrónico. En un plazo
              máximo de 24 horas hábiles, BAIRES FOOD SPAIN S.L. confirmará al Usuario la disponibilidad de
              stock, el precio aplicable, los gastos de envío y la fecha estimada de entrega. La aceptación
              expresa de dicho presupuesto por parte del Usuario formaliza el pedido y la consiguiente relación
              contractual.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              5. Precios e impuestos
            </h2>
            <p>
              Los precios se facilitan en presupuesto personalizado y se expresan en euros (€). Salvo indicación
              expresa, los precios incluyen el IVA aplicable según la normativa vigente. Los gastos de envío,
              cuando corresponda, se detallarán de forma independiente en el presupuesto.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              6. Forma de pago
            </h2>
            <p>
              El pago de los pedidos se realizará mediante los medios acordados con BAIRES FOOD SPAIN S.L. en
              cada presupuesto (transferencia bancaria, Bizum, tarjeta o, en el caso de clientes recurrentes
              HORECA y distribuidores, mediante las condiciones de crédito previamente pactadas).
            </p>
          </div>

          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              7. Envío y entrega
            </h2>
            <p>
              BAIRES FOOD SPAIN S.L. distribuye en cadena de frío validada a la España peninsular, Islas
              Baleares, Canarias y a los principales mercados de la Unión Europea. Los plazos de entrega
              estimados se comunican en el presupuesto y dependen del destino, la disponibilidad y el operador
              logístico utilizado. El riesgo y la propiedad de los productos se transmiten al Usuario en el
              momento de la entrega.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              8. Devoluciones y cancelaciones
            </h2>
            <p>
              Al tratarse de productos alimenticios perecederos sujetos a cadena de frío, queda excluido el
              derecho de desistimiento al amparo del artículo 103 del Real Decreto Legislativo 1/2007 (Ley
              General para la Defensa de los Consumidores y Usuarios). No obstante, si el producto recibido
              presentara defectos, daños o no se ajustara a lo solicitado, el Usuario deberá notificarlo en un
              plazo máximo de 24 horas desde la recepción, aportando fotografías. BAIRES FOOD SPAIN S.L.
              procederá a la reposición o al abono correspondiente según el caso.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              9. Garantía y reclamaciones
            </h2>
            <p>
              Todos los productos cumplen con la normativa sanitaria y de etiquetado vigente en la Unión
              Europea. Para cualquier incidencia o reclamación, el Usuario puede dirigirse a{" "}
              <a href="mailto:contacto@lacriollita.eu" className="text-wine hover:text-wine-hover underline-offset-4 hover:underline">contacto@lacriollita.eu</a>. Asimismo, los consumidores residentes en la Unión Europea pueden
              recurrir a la plataforma europea de resolución de litigios en línea, disponible en{" "}
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer" className="text-wine hover:text-wine-hover underline-offset-4 hover:underline">
                ec.europa.eu/consumers/odr
              </a>.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              10. Propiedad intelectual e industrial
            </h2>
            <p>
              Todos los contenidos del sitio web (textos, fotografías, imágenes, logotipos, marca registrada{" "}
              <em>La Criollita</em>, vídeos y diseño) son propiedad de BAIRES FOOD SPAIN S.L. o de terceros
              titulares con los que existe un acuerdo de uso, y están protegidos por la normativa nacional e
              internacional de propiedad intelectual e industrial. Queda prohibida su reproducción,
              distribución o uso sin autorización previa por escrito.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              11. Protección de datos personales
            </h2>
            <p>
              El tratamiento de los datos personales facilitados por el Usuario a través de los formularios del
              sitio web se rige por la{" "}
              <a href="/politica-privacidad" className="text-wine hover:text-wine-hover underline-offset-4 hover:underline">
                Política de Privacidad
              </a>, que forma parte integrante de las presentes Condiciones.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              12. Modificaciones
            </h2>
            <p>
              BAIRES FOOD SPAIN S.L. se reserva el derecho a modificar las presentes Condiciones Generales en
              cualquier momento. La versión vigente será la publicada en esta página en el momento del acceso
              del Usuario.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              13. Legislación aplicable y jurisdicción
            </h2>
            <p>
              Las presentes Condiciones se rigen por la legislación española. Para la resolución de cualquier
              controversia derivada del acceso o uso del sitio web o de la contratación de productos, las
              partes se someten a los Juzgados y Tribunales competentes de Palma de Mallorca, salvo que la
              normativa aplicable en materia de consumo establezca otro fuero imperativo.
            </p>
          </div>

          <div className="pt-8 border-t border-bone">
            <p className="text-sm italic">
              Última actualización: enero de 2026. BAIRES FOOD SPAIN S.L., CIF B-01998939.
            </p>
          </div>
        </article>
      </section>
    </div>
  );
};

export default TerminosCondiciones;
